import dayjs from 'dayjs';

import {
  allowedDateFieldEntry,
  applyDateMask,
  DateTimeFormat,
  DateTimeHelper,
  DayjsFormatMapper,
} from '@xemplo/date-time';

import { DateValue } from './date-field.types';

export { allowedDateFieldEntry, applyDateMask };

export function getFieldValues(
  value?: DateValue,
  format: DayjsFormatMapper = DateTimeFormat.Default,
) {
  if (value instanceof Date) {
    return {
      inputValue: dayjs(value).format(format),
      calendarValue: value,
    };
  }
  const isValid = DateTimeHelper.isValidDate(value, format);
  return {
    inputValue: value ?? '',
    // Note: This allowing handling single and double digits
    // Eg: 01/12/2024 or 1/12/2024 will both work
    calendarValue: isValid
      ? dayjs(value, [format, DayjsFormatMapper[format]]).toDate()
      : null,
  };
}

export function createDateChangeEvent(value?: string) {
  return {
    target: { value },
    currentTarget: { value },
  } as React.ChangeEvent<HTMLInputElement>;
}

export function getDisplayValue(
  value?: DateValue,
  format: DayjsFormatMapper = DateTimeFormat.Default,
) {
  if (value instanceof Date) {
    return dayjs(value).format(format);
  }
  return value ?? '';
}

export function isDateInputValid(
  value?: DateValue,
  required?: boolean,
  format: DayjsFormatMapper = DateTimeFormat.Default,
) {
  if (!required && !value) return true;
  if (value instanceof Date) return !isNaN(value.getTime());
  return DateTimeHelper.isValidDate(value, format);
}
